module.exports = __webpack_public_path__ + "img/vertical-progress.5460c9ee.svg";